// extracted by mini-css-extract-plugin
export default {"root":"jMO4TW"};